import { Flex, Text } from '@chakra-ui/react';

import { IdDocumentCase } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Guidance, {
  GuidanceStep,
} from 'features/Onboarding/components/Guidance';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import { locales } from './locales';

interface GuideProps {
  onContinue: () => void;
  isAllowedToSkipOnfidoSelfie: boolean;
  idDocumentCase: IdDocumentCase;
}

const Guide = asBentoPage<GuideProps>(
  ({
    idDocumentCase,
    isAllowedToSkipOnfidoSelfie,
    Layout,
    onContinue,
    onPrev,
  }) => {
    const identityGuidanceSteps = [
      {
        description:
          idDocumentCase === IdDocumentCase.AcceptedPassportOrIdCard
            ? locales.steps.id.description
            : undefined,
        title: locales.steps.id.title[idDocumentCase],
      },
      { title: locales.steps.verification.title },
    ];

    const identityStepsWithOnfido = [
      identityGuidanceSteps[0],
      {
        description: locales.steps.photo.description,
        title: locales.steps.photo.title,
      },
      identityGuidanceSteps[1],
    ] as GuidanceStep[];

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Flex direction="column" height={{ base: 'full', md: 'auto' }}>
          <Heading marginBottom="space-24" size="lg">
            {locales.title}
          </Heading>

          <Text marginBottom="space-56">{locales.subtitle}</Text>

          <Guidance
            steps={
              isAllowedToSkipOnfidoSelfie
                ? identityGuidanceSteps
                : identityStepsWithOnfido
            }
          />

          <Button
            marginBottom="space-40"
            marginTop="space-56"
            onClick={onContinue}
            type="submit"
          >
            {locales.cta}
          </Button>
        </Flex>
      </Layout>
    );
  },
);

export default Guide;
